import {VerticalLineNewIcon} from '@time-webkit/all/icons/vertical-line-new';

import styles from './divider.module.css';

export const Divider = () => (
    <div className={styles.divider}>
        <VerticalLineNewIcon />
    </div>
);
